import { render, staticRenderFns } from "./PresenceIndicatorsMenu.vue?vue&type=template&id=52d5dc8b&"
import script from "./PresenceIndicatorsMenu.vue?vue&type=script&lang=js&"
export * from "./PresenceIndicatorsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports